import React, {CSSProperties, useEffect, useState} from 'react';
import {ErrorMessage, Field} from 'formik';
import './MikaTextInput.scss'
import classNames from "classnames";


interface Props{
  style?: CSSProperties;
  labelKey?: string;
  name?: string;
  type?: string;
  value?: any;
  placeholder?: string;
  flat?: boolean,
  bordered?: boolean,
  disabled?: boolean,
  className?: string,
  children?: JSX.Element | JSX.Element[]
  onChange?: (value: string) => void;
  // Optional keystroke controls. When none are set the field renders exactly as
  // before (untouched for every existing caller). `restrict` filters characters
  // as they're typed/pasted; `maxLength` hard-caps the length; `inputMode` hints
  // the mobile keyboard. Used to block invalid input at the source (e.g. digits
  // only for phone / business number) rather than only rejecting it on save.
  maxLength?: number;
  inputMode?: 'text' | 'numeric' | 'tel' | 'decimal' | 'search' | 'email' | 'url';
  restrict?: 'digits' | 'phone';
}

const MikaTextInput: React.FC<Props> = (props: Props) => {

  function returnErrorMessage(errorMessage){
    return <p className='errorMessage'>{errorMessage}</p>
  }

  function onChangeEvent(textValue: string) {
    if(props?.onChange){
      props?.onChange(textValue)
    }
  }

  // Strip disallowed characters, then hard-cap length. Done in JS (not via the
  // HTML maxLength attr) so a paste like "ab12cd34" filters to digits BEFORE the
  // cap applies, instead of the browser counting the letters against the limit.
  function sanitizeValue(raw: string): string {
    let v = raw
    if (props.restrict === 'digits') v = v.replace(/\D/g, '')
    else if (props.restrict === 'phone') v = v.replace(/[^0-9+()\-\s]/g, '')
    if (props.maxLength != null) v = v.slice(0, props.maxLength)
    return v
  }
  const isEnhanced = !!props.restrict || props.maxLength != null || !!props.inputMode

  return <div className={classNames({
    ['mikaTextInputWrapper']: true,
    ['flat']: props.flat,
    ['bordered']: props.bordered,
    // ['invalid']: isInvalid,
    [props.className]: props.className
  })}>
    { props.children && <span>{props.children}</span> }
    { props.labelKey && <label> {props.labelKey}</label> }
    { props.value !== undefined ?
        <Field value={props?.value || ""} onChange={(inputElement: React.ChangeEvent<HTMLInputElement>)=> onChangeEvent(inputElement.target.value)} placeholder={props.placeholder} name={props.name} type="text" disabled={props.disabled} />
    :
        <>
          { isEnhanced ?
            <Field name={props.name}>
              {({ field, form }: any) => (
                <input
                  {...field}
                  type="text"
                  inputMode={props.inputMode}
                  placeholder={props.placeholder}
                  disabled={props.disabled}
                  onChange={(e) => form.setFieldValue(props.name, sanitizeValue(e.target.value))}
                />
              )}
            </Field>
          :
            <Field placeholder={props.placeholder} name={props.name} type="text" disabled={props.disabled} />
          }
          <ErrorMessage name={props.name}>{message => returnErrorMessage(message)}</ErrorMessage>
        </>
    }
  </div>
}


export default MikaTextInput;
